/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import FontFa from "../../../components/fontFa/fontFa";
import { Box } from "../../../components/box";
import { openUrl } from "../../../helper/util";
import { Routes } from "../../../AppRoutes";
import LinkDocumentModal from "../modal/link-document-modal";
import { getDDMMYYYFormat, getDiffDay } from "../../../helper/dateTimeHelper";
import { getEnv } from "../../../AppConfigs";
import { Spin, Table } from "antd";
import { TableHelpers } from "../../../helper/TableHelper";
import { ColumnsType } from "antd/lib/table";
import { DocumentService } from "../../../services/document/document.service";
import { useUser } from "../../../hook";
import { useSearchParams } from "../../../hook/use-search-params";
import { useDocumentLinkById } from "../hooks/document-link/use-document-link";
import { useDocumentLinkedById } from "../hooks/document-link/use-document-linked";
import { useCreateDocumentLink } from "../hooks/document-link/use-create-document-link";
import { useUpdateDocumentLink } from "../hooks/document-link/use-update-document-link";
const listId = getEnv("REACT_APP_PUBLIC_FOLDER_AND_FILE_SP_LIST_ID");

export const DocumentLink = (props: any) => {
  const { document, isReadOnly, visible } = props;
  const [openLinkDocumentModal, setOpenLinkDocumentModalModal] = useState(false);
  const [isUrlLink, setUrlLink] = useState(false);
  const { checkCurrentUser } = useUser();
  const { searchParams } = useSearchParams();
  const status = searchParams.get("status");
  const id = document.docWorkingId || document.docId;
  const { data: documentLinkData, isLoading } = useDocumentLinkById(id);
  const { data: documentLinkedData } = useDocumentLinkedById(id);
  const { createDocumentLink } = useCreateDocumentLink();
  const { updateDocumentLink } = useUpdateDocumentLink();

  const columns: ColumnsType<any> = [
    {
      title: "Tên tài liệu",
      dataIndex: "docLinkTitle",
      key: "docLinkTitle",
      render: (docLinkTitle: string, record: any) =>
        isDocumentExpired(record.docLinkExpiredDate) ? (
          <p className="text-danger text-decoration-underline">
            {record.docCode === "url" ? docLinkTitle + " (Trang web bên ngoài)" : docLinkTitle}
          </p>
        ) : record.docCode === "url" ? (
          docLinkTitle + " (Trang web bên ngoài)"
        ) : (
          docLinkTitle
        ),
      ...TableHelpers.searchInput({
        dataIndex: "Title",
      }),
    },
    {
      title: "Tình trạng",
      dataIndex: "docLinkExpiredDate",
      key: "docLinkExpiredDate",
      width: 120,
      render: (value: string) => (isDocumentExpired(value) ? <p className="text-danger">Lỗi thời</p> : "Hiệu lực"),
      filters: [
        {
          text: "Hiệu lực",
          value: false,
        },
        {
          text: "Lỗi thời",
          value: true,
        },
      ],
      onFilter: (status: any, record) => isDocumentExpired(record.docLinkExpiredDate) === status,
    },
    {
      title: "Ngày hết hạn",
      dataIndex: "docLinkExpiredDate",
      key: "docLinkExpiredDate",
      width: 150,
      render: (value: string, record: any) =>
        isDocumentExpired(record.docLinkExpiredDate) ? (
          <p className="text-danger">{getDDMMYYYFormat(value)}</p>
        ) : (
          getDDMMYYYFormat(value)
        ),
      ...TableHelpers.searchRangePicker({ dataIndex: "effectiveTo" }),
    },
    {
      dataIndex: "action",
      width: 50,
      align: "center" as const,
      render: (_: any, record: any) =>
        !status &&
        checkCurrentUser(document.userEmail) &&
        !record.isDeleted && (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              onRemoveLink(record);
            }}
            variant="outline-dark"
          >
            <FontFa name="faTrash" />
          </Button>
        ),
    },
  ];

  const columnsLinked: ColumnsType<any> = [
    {
      title: "Tên tài liệu",
      dataIndex: "docTitle",
      key: "docTitle",
      render: (title: string, record: any) =>
        isDocumentExpired(record.effectiveTo) ? (
          <p className="text-danger text-decoration-underline">
            {record.docCode === "url" ? title + " (Trang web bên ngoài)" : title}
          </p>
        ) : record.docCode === "url" ? (
          title + " (Trang web bên ngoài)"
        ) : (
          title
        ),
      ...TableHelpers.searchInput({
        dataIndex: "Title",
      }),
    },
    {
      title: "Tình trạng",
      dataIndex: "effectiveTo",
      key: "effectiveTo",
      width: 120,
      render: (value: string, record: any) =>
        isDocumentExpired(value) ? <p className="text-danger">Lỗi thời</p> : "Hiệu lực",
      filters: [
        {
          text: "Hiệu lực",
          value: false,
        },
        {
          text: "Lỗi thời",
          value: true,
        },
      ],
      onFilter: (status: any, record) => isDocumentExpired(record.docLinkExpiredDate) === status,
    },
    {
      title: "Ngày hết hạn",
      dataIndex: "effectiveTo",
      key: "effectiveTo",
      width: 150,
      render: (value: string) =>
        isDocumentExpired(value) ? <p className="text-danger">{getDDMMYYYFormat(value)}</p> : getDDMMYYYFormat(value),
      ...TableHelpers.searchRangePicker({ dataIndex: "docLinkExpiredDate" }),
    },
    {
      dataIndex: "action",
      width: 50,
      align: "center" as const,
    },
  ];

  const openLink = (link: any) => {
    let url = link.docLinkUrl;
    if (link.docLinkId) {
      url =
        Routes.documentDetail.path.replace(":id", link.docLinkId) +
        `?fileId=${link.docLinkFileId}&action=info&status=publish`;
    }

    if (url) openUrl(url);
  };

  const openLinkedLink = (link: any) => {
    if (link.docId) {
      const url = Routes.documentDetail.path.replace(":id", link.docId) + `?fileId=${link.docLinkFileId}&action=info`;
      openUrl(url);
    }
  };

  const toggleLinkDocumentModal = () => {
    setOpenLinkDocumentModalModal(!openLinkDocumentModal);
  };

  const onLinkedDocuments = async (files: any) => {
    const oldLinks = documentLinkData?.data;
    let addedLinks = files.filter(
      (f: any) => f.id != document.fileId && (!f.id || !oldLinks.find((ol: any) => ol.docLinkFileId === f.id)),
    );
    if (addedLinks) {
      let publishDocumentInfo: any = {};
      if (document?.docStatusId === 8) {
        const res = await DocumentService.getPublicDocumentInfoFromWorkingDocument(document?.docId);
        publishDocumentInfo = { ...res };
      }

      addedLinks.forEach((file: any) => {
        const fields = {
          Title: document.Title || document.nameWithoutExt || document.name,
          effectiveTo: publishDocumentInfo?.effectiveTo,
          docId: document.docId,
          docCode: document.docCode,
          docTypeId: document.docTypeId,
          docInfoLookupId: document.id,
          docFileId: document.fileId,
          docUrl: document.docUrl,
          docLinkId: file.docWorkingId,
          docLinkTitle: file.Title || file.nameWithoutExt || file.name,
          docLinkTypeId: file.docTypeId,
          docLinkCode: file.docCode || "url",
          docLinkTypeCode: file.docCode || "url",
          docLinkInfoLookupId: file.docInfoId,
          docLinkFileId: file.id,
          docLinkUrl: file.url,
          docLinkExpiredDate: file.expiredDate,
        };

        createDocumentLink(fields);
      });
      toggleLinkDocumentModal();
    } else toggleLinkDocumentModal();
  };

  const onRemoveLink = async (link: any) => {
    if (link?.id) {
      const body = {
        isDeleted: true,
      };
      updateDocumentLink({ id: link.id, body });
    }
  };

  const isDocumentExpired = (effectiveTo: string) => {
    const today = new Date();
    if (!effectiveTo) return false;
    return getDiffDay(effectiveTo, today.toDateString()) >= 0;
  };

  // if (isLoading) return <Spin />;

  return (
    visible && (
      <>
        <Container>
          <Box title={"Liên kết tài liệu"}>
            <Container>
              <Row>
                <Col xs={12} sm={12} md={{ span: 10, offset: 1 }}>
                  <div className="Table table-responsive-md">
                    <Table
                      columns={columns}
                      dataSource={documentLinkData?.data}
                      onRow={(record) => ({
                        onClick: () => openLink(record),
                        style: {
                          cursor: "pointer",
                          textDecoration: record.isDeleted ? "line-through" : "",
                          color: record.isDeleted ? "red" : "",
                        },
                      })}
                    />
                  </div>
                </Col>

                <Col xs={12} sm={12} md={{ span: 10, offset: 1 }}>
                  <div className="Table table-responsive-md">
                    <Table
                      columns={columnsLinked}
                      dataSource={documentLinkedData?.data}
                      onRow={(record) => ({
                        onClick: () => openLinkedLink(record),
                        style: {
                          cursor: "pointer",
                          textDecoration: record.isDeleted ? "line-through" : "",
                          color: record.isDeleted ? "red" : "",
                        },
                      })}
                    />
                  </div>
                </Col>
                {!isReadOnly && (
                  <Col xs={12} sm={12} md={{ span: 10, offset: 1 }}>
                    <div className="d-flex justify-content-end mt-5">
                      <Button
                        onClick={() => {
                          toggleLinkDocumentModal();
                          setUrlLink(true);
                        }}
                        variant="outline-dark"
                        className="mr-3"
                      >
                        {"Liên kết Url"}
                      </Button>
                      <Button
                        onClick={() => {
                          toggleLinkDocumentModal();
                          setUrlLink(false);
                        }}
                        variant="info"
                      >
                        {"Liên kết tập tin"}
                      </Button>
                    </div>
                  </Col>
                )}
              </Row>
            </Container>
          </Box>
        </Container>

        <LinkDocumentModal
          onClose={toggleLinkDocumentModal}
          isOpen={openLinkDocumentModal}
          isUrl={isUrlLink}
          data={document}
          onLinked={onLinkedDocuments}
          listId={listId}
        />
      </>
    )
  );
};
